<template>
    <div class="m-invest-block">
      <div class="m-invest-block-title">
        <p class="m-invest-title-name">Похожие продукты</p>
      </div>
      <div class="m-invest-blocks slider-main-container">
        <swiper
          :slidesPerView="1"
          :spaceBetween="30"
          :freeMode="true"
          :autoplay="{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }"
          :navigation="true"
          :pagination="{ clickable: true }"
          :breakpoints="{
            '575': { slidesPerView: 2, spaceBetween: 30 },
            '768': { slidesPerView: 2, spaceBetween: 40 },
            '1024': { slidesPerView: 3, spaceBetween: 70 }
          }"
          :modules="modules"
          class="projectsTopSlider main-slide main-slide--with-nav"
        >
          <template #navigation-prev>
            <div class="custom-swiper-button prev-btn">
              <i class="fas fa-chevron-left"></i>
            </div>
          </template>
          <template #navigation-next>
            <div class="custom-swiper-button next-btn">
              <i class="fas fa-chevron-right"></i>
            </div>
          </template>
  
          <swiper-slide v-for="invest in products" :key="invest.id">
            <a class="m-invest-block2" :href="`/product/${invest.slug}`">
              <swiper
                :navigation="true"
                :pagination="true"
                :loop="true"
                :modules="modules"
                class="mySwiper singleProjectSlider"
              >
                <div class="img-wrap project-img-wrap">
                  <image-wrap
                    class="m-invest-img image"
                    :image="invest.main_image"
                    size="medium"
                  ></image-wrap>
                </div>
              </swiper>
            </a>
            <div class="m-invest-info">
              <a class="m-invest-block2" :href="`/product/${invest.slug}`">
                <p class="m-invest-name">{{ invest.title }}</p>
                <div class="m-invest-info-div"></div>
              </a>
              <div class="m-contacts-div">
                <order-popup-btn-small :product="invest" />
                <a :href="`/product/${invest.slug}`" class="m-contact-a">
                  <i class="fas fa-file-signature m-contact-img" width="18"></i>
                  <p class="m-contact-p">Код-{{ invest.sku }}</p>
                </a>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, defineProps } from 'vue';
  import axios from 'axios';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Autoplay, Navigation, Pagination } from 'swiper/modules';
  
  import 'swiper/css';
  import 'swiper/css/navigation';
  import 'swiper/css/pagination';
  
  const props = defineProps(['product_id']);
  const products = ref([]);
  const modules = [Navigation, Pagination, Autoplay];
  
  async function getProducts(id) {
    const { data } = await axios.get('get-related-products/' + (id || ''));
    products.value = data.products;
  }
  getProducts(props.product_id);
  </script>
  
  <style>
  .m-invest-block {
    margin-top: 50px;
    padding-bottom: 50px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 50px;
  }
  
  @media screen and (max-width: 1024px) {
    .m-invest-block {
      gap: 30px;
      margin-top: 80px;
      padding-bottom: 20px;
    }
  }
  
  @media screen and (max-width: 768px) {
    .m-invest-block {
      margin-top: 40px;
    }
  }
  
  .m-invest-blocks {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 76px;
  }
  
  @media screen and (max-width: 1024px) {
    .m-invest-blocks {
      gap: 30px;
    }
  }
  
  .m-invest-block2 {
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .m-invest-img {
    width: 100%;
  }
  
  .m-invest-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 24px 24px 10px;
  }
  
  .m-invest-name {
    border-bottom: 2px solid #3c5757;
    font-size: 22px;
    color: #3c5757;
    margin-bottom: 16px;
    text-align: center;
  }
  
  @media screen and (max-width: 1024px) {
    .m-invest-name {
      font-size: 18px;
    }
  }
  
  .m-contacts-div {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .m-contact-a {
    display: flex;
    gap: 8px;
    align-items: center;
  }
  
  .m-contact-p {
    font-size: 14px;
    color: black;
    white-space: nowrap;
  }
  
  .m-contact-img {
    height: 15px;
    color: #3c5757;
  }
  
  .slider-main-container {
    position: relative;
    padding: 0 30px;
  }
  
  /* === Custom Swiper Buttons === */
  .custom-swiper-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.95);
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .custom-swiper-button:hover {
    background-color: #3c5757;
  }
  
  .custom-swiper-button i {
    font-size: 16px;
    color: #3c5757;
    transition: color 0.3s;
  }
  
  .custom-swiper-button:hover i {
    color: white;
  }
  
  .prev-btn {
    left: 0;
  }
  
  .next-btn {
    right: 0;
  }
  
  @media screen and (max-width: 768px) {
    .custom-swiper-button {
      width: 32px;
      height: 32px;
    }
  
    .custom-swiper-button i {
      font-size: 14px;
    }
  }
  </style>
  